module.exports = __webpack_public_path__ + "img/icon-teacher.8450594.png";